export default ({
  elementId,
  tileLayer,
  minZoom,
  maxZoom
}) => {
  const map = L.map(elementId)
  L.tileLayer(tileLayer, {
    minZoom,
    maxZoom
  }).addTo(map)
  return map
}



// WEBPACK FOOTER //
// ./src/scripts/init_leaflet.js